export class AccessType {
    id: string;
    name: string;
    constructor(accessType?: AccessType) {
        this.id = accessType?.id || "";
        this.name = accessType?.name || "";
    }
}
